import React from "react";
import Reports from "./Reports";

const WarehouseStockReport = () => <Reports reportType="warehouse" />;

export default WarehouseStockReport;
